//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Article from '@/modules/article/components/article-view-page.vue';
import Articles from '@/modules/article/components/articles-list-page.vue';
import { i18n } from '@/i18n';
// const pageSize= 3
export default {
     name: 'app-home-news',
     data(){
         return{
            //  article:false,
             beginIndex:0,
             endIndex:0,
             pageNum:1,
             showMoreEnabled: true,
             articles:[
                 {      id:1,
                     image:'/images/corona-test.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Should I get tested for coronavirus just for the heck of it?',
                     body:'Earlier in this pandemic, the shortage of tests for coronavirus was a major problem in fighting the of COVID-19. The shortage...',
                 },
                  {
                      id:2,
                     image:'/images/corona-LA.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:' Live updates: All coronavirus testing shuttered in Los Angeles.',
                     body:'Los Angeles Mayor Eric Garcetti said the city’s coronavirus testing centers were closed Saturday because of “safety worries ....',
                 },
                  {
                      id:3,
                     image:'/images/after-illness.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Long after the illness is gone, the damage from coronavirus remain',
                     body:' The roulette wheel of infection that determines which COVID-19 patients live and die has gripped the world in fear,but researchers ....',
                 },
                 {
                     id:4,
                     image:'/images/corona-test.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Should I get tested for coronavirus just for the heck of it?',
                     body:'Earlier in this pandemic, the shortage of tests for coronavirus was a major problem in fighting the of COVID-19. The shortage...',
                 },
                  {
                      id:5,
                     image:'/images/corona-LA.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:' Live updates: All coronavirus testing shuttered in Los Angeles.',
                     body:'Los Angeles Mayor Eric Garcetti said the city’s coronavirus testing centers were closed Saturday because of “safety worries ....',
                 },
                  {
                      id:6,
                     image:'/images/after-illness.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Long after the illness is gone, the damage from coronavirus remain',
                     body:' The roulette wheel of infection that determines which COVID-19 patients live and die has gripped the world in fear,but researchers ....',
                 },
                 {
                     id:7,
                     image:'/images/corona-test.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Should I get tested for coronavirus just for the heck of it?',
                     body:'Earlier in this pandemic, the shortage of tests for coronavirus was a major problem in fighting the of COVID-19. The shortage...',
                 },
                  {
                      id:8,
                     image:'/images/corona-LA.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:' Live updates: All coronavirus testing shuttered in Los Angeles.',
                     body:'Los Angeles Mayor Eric Garcetti said the city’s coronavirus testing centers were closed Saturday because of “safety worries ....',
                 },
                  {
                      id:9,
                     image:'/images/after-illness.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Long after the illness is gone, the damage from coronavirus remain',
                     body:' The roulette wheel of infection that determines which COVID-19 patients live and die has gripped the world in fear,but researchers ....',
                 },
                 {
                     id:10,
                     image:'/images/corona-test.svg',
                     date:'May 31, 2020 7:18 AM',
                     title:'Should I get tested for coronavirus just for the heck of it?',
                     body:'Earlier in this pandemic, the shortage of tests for coronavirus was a major problem in fighting the of COVID-19. The shortage...',
                 },
                //   {
                //       id:11,
                //      image:'/images/corona-LA.svg',
                //      date:'May 31, 2020 7:18 AM',
                //      title:' Live updates: All coronavirus testing shuttered in Los Angeles.',
                //      body:'Los Angeles Mayor Eric Garcetti said the city’s coronavirus testing centers were closed Saturday because of “safety worries ....',
                //  },
                //   {
                //       id:12,
                //      image:'/images/after-illness.svg',
                //      date:'May 31, 2020 7:18 AM',
                //      title:'Long after the illness is gone, the damage from coronavirus remain',
                //      body:' The roulette wheel of infection that determines which COVID-19 patients live and die has gripped the world in fear,but researchers ....',
                //  },
             ],
             showArticles:false,
             slicedArticles: []
         }
     },
     
     methods:{
          i18n(key, args) {
      return i18n(key, args);
    },
    
         showMoreArticles(){
            //  this.endIndex += 3;
            //  this.slicedArticles = this.articles.slice(0,this.endIndex)
            // console.log('articles');
            this.$router.push('/articles')
         },
         showArticle(){
            this.$router.push('/article')
         }
     },
     watch:{

         endIndex(newValue){
            //  console.log('new value',newValue)
             if(newValue >=  this.articles.length){
                //  console.log("disabled")
                 this.showMoreEnabled = false
             }
         }
       
     },
    async mounted(){
          this.slicedArticles = this.articles.slice(this.beginIndex,this.endIndex + 3)
          this.beginIndex += 3
          this.endIndex += 3
       
     },
    
      components: {
    [Article.name]: Article,
    [Articles.name]: Articles
  },
}
